import { default as videojs } from 'video.js';
import { ComponentBaseOptions } from '../models';
import Component = videojs.Component;

const VideoJsComponent: typeof videojs.Component = videojs.getComponent('Component');

export class ComponentBase extends VideoJsComponent {

    constructor(player: videojs.Player, options?: ComponentBaseOptions, readyCallback?: Component.ReadyCallback) {
        super(player, options, readyCallback);
    }
}
